import React, { useState } from 'react';
import GetIcon from '../../../../utils/Icon';
import VersionHistory from '../../../../utils/VersionHistory';
import Input from '../../../../Core/Fields/Floating/Input';
import Date from '../../../../Core/Fields/Floating/Date';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';

function Tab1({ fulldata, activityboll, order_id }) {
  const [showActivity, setShowActivity] = useState(true);

  return (
    <div
      className="row sidebarbox m-0 p-2"
      style={{
        borderRadius: "5px",
        maxHeight: "80vh",
        height: '74vh',
        overflowY: 'scroll',

      }}
    >
      {/* Top Section */}
      <div style={{maxHeight: "74vh"}}>


      <div  >
        <div className="d-flex gap-2 mb-2">
          <div className="col">
            <Input
              id="pickId"
              label="Pick Id"
              value={order_id}
              readOnly
              style={{ height: '30px', fontSize: '0.8rem' }}
            />
          </div>
          <div className="col">
            <Input
              id="orderDate"
              label="Order Date"
              value="2025-05-20"
              readOnly
              style={{ height: '30px', fontSize: '0.8rem' }}
            />
          </div>
        </div>

        <div className="col-12 mb-3">
          <Input
            id="customer"
            label="Customer"
            value={fulldata?.message?.customer || ''}
            readOnly
            style={{ height: '30px', fontSize: '0.8rem' }}
          />
        </div>


        <div className="col-12 mb-3">
          <Input
            id="order_type"
            label="Order Type"
            value={fulldata?.message?.order_type || ''}
            readOnly
            style={{ height: '30px', fontSize: '0.8rem' }}
          />
        </div>

        
        <div className="col-12 mb-3">
          <Input
            id="purpose"
            label="Purpose"
            value={fulldata?.message?.purpose || ''}
            readOnly
            style={{ height: '30px', fontSize: '0.8rem' }}
          />
        </div>

        {/* <div className="col-12 mb-3">
          <Input
            id="workOrder"
            label="Work Order"
            value="WO-000456"
            readOnly
            style={{ height: '30px', fontSize: '0.8rem' }}
          />
        </div> */}

        <div className="col-12 mb-3">
          <Input
            id="deliveryDate"
            label="Delivery Date"
            value="2025-05-22"
            readOnly
            style={{ height: '30px', fontSize: '0.8rem' }}
          />
        </div>
        <div className="col-12 mb-3" >
          <Input
            id="assigned to"
            label="Assigned To"
            value={fulldata?.message?.assigned_to}
            readOnly
            style={{ height: '30px' }}
          />
        </div>
      </div>
      {/* Activity Section */}
      <div >
        <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)}>
          <p className="firstcolor m-0">
            Activity
          </p>
          <GetIcon
            iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"}
            size={22}
          />
        </div>


        {showActivity && (
          <VersionHistory
            doctype="Pick List"
            docname={order_id}
            activityboll={activityboll}
          />
        )}
      </div>
      </div>

    </div>
  );
}

export default Tab1;
